import React, { useState } from 'react';
import { MTableBodyRow } from 'material-table';
import { Form } from 'react-bootstrap';

function TableRowWrapper(props) {
  const [data, setData] = useState(props.data);

  function handleInputChange(field, value) {
    const dataValue = { ...data };
    dataValue[field] = value;
    setData(dataValue);
  }
  // const handleInputChange = useCallback((field, value) => {
  //   const dataValue = { ...data };
  //   dataValue[field] = value;
  //   setData(dataValue);
  // }, []);

  return (
    <MTableBodyRow
      {...props}
      data={{
        ...data,
        handleInputChange: handleInputChange,
        setData
      }}
    />
  )
}

export default TableRowWrapper;